import { size } from 'lodash';

export default {
    buttons: {
        start: 'เริ่ม',
        end: 'จบกิจกรรม',
        submit: 'ส่ง',
        next: 'คำถามถัดไป',
        result: 'ดูผลลัพธ์',
        nextModule: 'ถัดไป',
        selfDone: 'เรียนด้วยตนเองเสร็จ',
        taskDone: 'การบ้านเสร็จ',
        moduleStart: 'เริ่มกิจกรรม',
    },
    teacher: {
        setting: 'ตั้งค่ากิจกรรม',
        wayOfProgress: 'วิธีดำเนินการ',
        wayOfReading: 'วิธีอ่าน',
        title: 'ชื่อกิจกรรม',
        guide: 'คู่มือกิจกรรม',
        tooltip: `
        <span class="tooltip_list">
            <strong>กับคุณครู</strong>
            <span>ทำไปทีละข้อพร้อมกับคุณครู</span>
         </span>
         <span class="tooltip_list">
            <strong>เรียนด้วยตนเอง</strong>
            <span>นักเรียนทำโจทย์ทั้งหมดตามจังหวะของตัวเอง</span>
        </span>
        `,

        screen: 'หน้าจอกิจกรรม',
        content: ({ values }: { values: { title?: string } }) => {
            const { title } = values;
            if (title) {
                return `เนื้อหากิจกรรม <span>${title}</span>`;
            }
            return 'เนื้อหากิจกรรม';
        },
        summary: 'สรุปกิจกรรม',
        addQuestions: {
            search: {
                empty: '✨เมื่อพิมพ์คำศัพท์ลงในช่องค้นหา ผลการค้นหาจากพจนานุกรมจะปรากฏที่นี่\nเมื่อวางข้อมูลที่คัดลอกจากชีตลงในช่องค้นหา\nจะถูกเพิ่มเข้าไปในคำศัพท์ที่รอลงทะเบียนทันที',
                placeholder: 'ค้นหาคำศัพท์ หรือคัดลอกและวางข้อมูลจาก Excel / Google Sheets',
            },
            wait: {
                empty: {
                    default: 'เมื่อรวบรวมคำศัพท์ไว้แล้ว กด [ลงทะเบียนในกิจกรรม] เพียงครั้งเดียวก็เพิ่มพร้อมกันทั้งหมด',
                    choice: 'เมื่อรวบรวมคำศัพท์ไว้แล้ว กด [ลงทะเบียนในกิจกรรม] เพียงครั้งเดียวก็เพิ่มพร้อมกันทั้งหมด\nหากเว้นตัวเลือกคำตอบผิดของคำศัพท์ที่รออยู่ไว้ว่าง ระบบจะเติมให้อัตโนมัติจากคำศัพท์อื่นเมื่อลงทะเบียน\nข้อมูลชีตรับตามลำดับคอลัมน์ คำศัพท์ / ความหมาย / คำตอบผิด1 / คำตอบผิด2 / คำตอบผิด3',
                },
            },
            infoTitle: 'สามารถค้นหาคำศัพท์ที่ต้องการเพื่อเพิ่มโจทย์ของตัวเองได้',
            infoDesc: {
                default: 'คัดลอกจาก Excel หรือ Google Sheets มาวางก็ลงทะเบียนได้ในครั้งเดียว!',
                choice: 'คัดลอกจาก Excel หรือ Google Sheets มาวางก็ลงทะเบียนได้ในครั้งเดียว\nและหากตัวเลือกคำตอบผิดว่างอยู่ ระบบจะเติมให้อัตโนมัติ!',
            },
            noMeaning: {
                title: 'มีคำศัพท์ที่ไม่มีความหมาย!',
                message: 'มีคำศัพท์ที่ไม่มีความหมาย<br />จะลงทะเบียนเฉพาะคำที่เหลือโดยไม่รวมคำนี้ไหม?',
                enterMeaning: 'กรอกความหมาย',
                submitRest: 'ลงทะเบียนเฉพาะที่เหลือ',
            },
            invalidChar: {
                title: 'มีสัญลักษณ์ที่ไม่ถูกต้อง!',
                message: 'ในช่องความหมายกรอกได้เฉพาะภาษาเกาหลี ภาษาอังกฤษ ตัวเลข และสัญลักษณ์บางตัวเท่านั้น',
                invalidCharsLabel: 'อักขระที่ไม่อนุญาตในเนื้อหาที่กรอก:',
            },
            registerResult: 'ผลการลงทะเบียน',
        },
    },
    alert: {
        wrong: 'อุ๊ย ผิดแล้ว ลองอีกครั้งนะ',
        chancesExhausted: 'อุ๊ย ผิดแล้ว! ลองดูเฉลยกันนะ',
        waiting: () => {
            const messages = ['เสร็จแล้ว! รอสักครู่นะ', 'เยี่ยม! รอสักครู่นะ', 'ทำได้ดี! รอสักครู่นะ'];
            return messages[Math.floor(Math.random() * size(messages))];
        },
    },
    question: 'ข้อ',
    answerRate: 'อัตราการตอบถูก',
    relation: 'ความสัมพันธ์แบบ{relation}',
    allDone: 'ทำครบทุกข้อแล้ว จบกิจกรรมได้เลย!',
    champion: 'แชมเปียน',
    allSelect: 'เลือกทั้งหมด',
    majorVocabulary: 'คำศัพท์สำคัญ',
    remainingVocabulary: 'คำศัพท์ที่เหลือ',
    customVocabulary: 'คำศัพท์ที่ฉันเพิ่ม',
    goWatingroom: 'ไปที่ห้องรอของนักเรียนทั้งหมด',
    students: {
        errorTooltip: 'นักเรียนอยู่ในสถานะออฟไลน์',
        progress: {
            title: ({ values }: { values: { isOngoing: boolean } }) => {
                const { isOngoing } = values;
                return `${isOngoing ? 'สถานะ' : 'ผลลัพธ์'}ของนักเรียนแต่ละคน`;
            },
        },
        standby: 'ยังไม่เริ่ม',
        notAttended: 'ไม่เข้าร่วม',
        inProgress: 'กำลังทำ',
        notCompleted: 'ยังไม่เสร็จ',
        completed: 'เสร็จสิ้น',
    },
    modal: {
        title: 'จบกิจกรรม',
        message: 'จะจบกิจกรรมไหม?',
    },
    state: {
        correct: 'ตอบถูก',
        wrong: 'ตอบผิด',
    },
    toast: {
        addStarStudent: 'ให้ดาวชมเชยแก่นักเรียน {name} แล้ว',
        addAllStar: 'ให้ดาวชมเชยแก่นักเรียนทั้งหมด ({length} คน) แล้ว',
        failedStar: 'ให้ดาวชมเชยไม่สำเร็จ',
        undo: 'เลิกทำ',
        undoFailed: 'เลิกทำการให้ดาวชมเชยไม่สำเร็จ',
        movedToWaitingRoom: 'นักเรียนทุกคนย้ายไปที่ห้องรอแล้ว',
    },
};
